<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-table
      v-loading="dataListLoading"
      :data="dataList"
      border
      @selection-change="dataListSelectionChangeHandle"
      @sort-change="dataListSortChangeHandle"
      style="width: 100%;"
      max-height="400"
      :cell-style="cellStyle"
      :row-style="rowStyle"
    >
      <el-table-column
        prop="dictName"
        :label="$t('dict.dictName')"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="dictType"
        :label="$t('dict.dictType')"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="dataForm.pid !== '0'">{{ scope.row.dictType }}</span>
          <el-button v-else type="text" @click="childHandle(scope.row)">{{
            scope.row.dictType
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        v-if="dataForm.pid !== '0'"
        prop="dictValue"
        label="字典值"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="sort"
        :label="$t('dict.sort')"
        sortable="custom"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="remark"
        :label="$t('dict.remark')"
        header-align="center"
        align="center"
      ></el-table-column>

      <el-table-column
        :label="$t('handle')"
        fixed="right"
        header-align="center"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <el-button
            v-if="$hasPermission('sys:dict:update')"
            type="text"
            size="small"
            @click="addOrUpdateHandle(scope.row)"
            >{{ $t('update') }}</el-button
          >
          <el-button
            v-if="$hasPermission('sys:dict:delete')"
            type="text"
            size="small"
            @click="deleteHandle(scope.row.id)"
            >{{ $t('delete') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <add-or-update
      v-if="addOrUpdateVisible"
      ref="addOrUpdate"
      @refreshDataList="getDataList"
    ></add-or-update>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './add-or-update'
export default {
  mixins: [mixinViewModule],
  components: { AddOrUpdate },
  props: {
    pid: '',
  },
  data() {
    return {
      cellStyle: {
        padding: '4px',
      },
      rowStyle: {
        height: '10px',
      },
      mixinViewModuleOptions: {
        activatedIsNeed: false,
        getDataListURL: '/sys/dict/list',
      },
      dataForm: {
        pid: '0',
        dictName: '',
        dictType: '',
        dictValue: '',
      },
    }
  },
  watch: {
    pid() {
      this.dataForm.pid = this.pid
      this.getDataList()
    },
  },
  activated() {
    if (this.pid) {
      this.dataForm.pid = this.pid
      this.getDataList()
    }
  },
  methods: {
    addOrUpdateHandle(row = {}) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.id = row.id
        this.$refs.addOrUpdate.init()
      })
    },
  },
}
</script>
